import { render, staticRenderFns } from "./CreateReturnShipmentModal.vue?vue&type=template&id=5f7b39f9&scoped=true"
import script from "./CreateReturnShipmentModal.vue?vue&type=script&lang=js"
export * from "./CreateReturnShipmentModal.vue?vue&type=script&lang=js"
import style0 from "./CreateReturnShipmentModal.vue?vue&type=style&index=0&id=5f7b39f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7b39f9",
  null
  
)

export default component.exports